// EGN Header: hover intent til mega-panelerne i egn-desktop-nav.
// Åbn efter 90 ms, luk efter 280 ms, og spring et faneskift over, hvis musen blot krydser en nabofane på vej ned i panelet.
(() => {
  const OPEN_DELAY = 90
  const CLOSE_DELAY = 280
  const items = [...document.querySelectorAll('details[data-egn-hover]')]
  if (!items.length) return

  let openTimer = null
  let closeTimer = null
  const canHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches

  const setOpen = (d, open) => {
    const s = d.querySelector('summary')
    if (open) d.setAttribute('open', '')
    else d.removeAttribute('open')
    s && s.setAttribute('aria-expanded', open ? 'true' : 'false')
  }
  const closeAll = (except) => items.forEach((d) => d !== except && d.hasAttribute('open') && setOpen(d, false))
  const current = () => items.find((d) => d.hasAttribute('open'))

  items.forEach((d) => {
    const summary = d.querySelector('summary')
    const panel = d.querySelector('.egn-mega')

    d.addEventListener('mouseenter', () => {
      if (!canHover()) return
      clearTimeout(closeTimer)
      clearTimeout(openTimer)
      // Er et andet panel allerede åbent, skiftes der hurtigt. Ellers ventes der lidt, så et hurtigt strejf ikke åbner.
      const delay = current() && current() !== d ? OPEN_DELAY * 1.5 : OPEN_DELAY
      openTimer = setTimeout(() => { closeAll(d); setOpen(d, true) }, delay)
    })
    d.addEventListener('mouseleave', () => {
      if (!canHover()) return
      clearTimeout(openTimer)
      closeTimer = setTimeout(() => setOpen(d, false), CLOSE_DELAY)
    })
    // Inde i panelet: annullér et ventende faneskift (musen krydsede en nabofane på vej ned).
    panel && panel.addEventListener('mouseenter', () => { clearTimeout(openTimer); clearTimeout(closeTimer) })

    summary.addEventListener('click', (e) => {
      e.preventDefault()
      clearTimeout(openTimer)
      if (d.hasAttribute('open') && canHover() && summary.dataset.link) {
        window.location.href = summary.dataset.link
        return
      }
      const willOpen = !d.hasAttribute('open')
      closeAll(d)
      setOpen(d, willOpen)
    })

    d.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && d.hasAttribute('open')) {
        setOpen(d, false)
        summary.focus()
      }
    })
    d.addEventListener('focusout', (e) => {
      if (!d.contains(e.relatedTarget)) setOpen(d, false)
    })
  })

  // Escape lukker også, når panelet er åbnet med musen (fokus er da ikke inde i menuen).
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    const d = current()
    if (!d) return
    setOpen(d, false)
    if (d.contains(document.activeElement)) d.querySelector('summary').focus()
  })

  document.addEventListener('click', (e) => {
    if (!e.target.closest('details[data-egn-hover]')) closeAll()
  })
})()
